define(function (require) {
    'use strict';

    var Marionette = require('marionette');
    var AppConfig = require('config/application');

    return Backbone.Model.extend({
        /*
         *	function urlRoot()
         *	Get sync url
         *	@return {string} url
         */
        urlRoot: function () {
            return AppConfig.host + '/rest/session';
        },

        /*
         *	function initialize()
         *	Initialize
         */
        initialize: function () {
            var that = this;

            // Add onChange event
            // Sync with server
            that.on('change', function () {
                that.save(that.toJSON(), {wait: false, silent: true});
            });
        },

        /*
         *	function parse()
         *	Parse server response when sync
         *	@param 	{object}	response
         *	@return {object}	result
         */
        parse: function (response) {
            if (response.result !== undefined) {
                return response.result.data;
            } else {
                return response;
            }
        }
    });
});
